import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoveDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"move_down"}/>
}
